import React from 'react';
import { Redirect } from "react-router-dom";
import SplitterLayout from 'react-splitter-layout';
import 'react-splitter-layout/lib/index.css';
import Header from './Toolbar/Header'
import Folders from './SideDraw/Folders'
import WorkPlace from './WorkPlace/WorkPlace'
import ChangeRole from './SideDraw/Role/Role'
import Task from './SideDraw/Task/Task'
import Context from './SideDraw/Context/Context'
import Footer from './Footer/Footer'
import FetchData from '../Utils/FetchData';
//import Dxdata from '../Utils/js-bridge/DXData';
import  DXData from '../Utils/js-bridge/DXData';
//import './Taskview.css'
import '../TaskView/Taskview.css'
import LogoTA from '../../images/ta.png';
import { connect } from 'react-redux'
import { LoadPanel } from 'devextreme-react/load-panel';
//import { Accordion } from 'devextreme-react';
import List from 'devextreme-react/list';
import setRoleIdAction from '../../actions/setRoleIdAction'
import setTaskIdAction from '../../actions/setTaskIdAction'
import setDirectoryIdAction from '../../actions/setDirectoryIdAction'
import setFolderIdAction from '../../actions/setFolderIdAction'
import setTaskNameAction from '../../actions/setTaskNameAction'
import setFolderNameAction from '../../actions/setFolderNameAction'
import setRoleNameAction from '../../actions/setRoleNameAction'
import setCurrentObjectId from '../../actions/setCurrentObjectId'
import setActionRemoveTab from '../../actions/setActionRemoveTab';
import setNotificationsCountAction from '../../actions/setNotificationsCountAction'
import setActionNotifications from '../../actions/setActionNotifications'
import setCurrentFooterAction from '../../actions/setActionFooter';
import setActionFolderExpColaps from '../../actions/setActionFolderExpColaps';
import setContextsExpandCollapse from '../../actions/setContextsExpandCollapse';
import setCurrentCache from '../../actions/setActionCache';
import setActiondropdownFlag from '../../actions/setActiondropdownFlag';
import SvgExpandCollapseRight from '../../iconComponents/rightCollapseExpandIcon'
import SvgExpandCollapseLeft from '../../iconComponents/leftCollapseiconBlue'
import setActionDashboardlist from '../../actions/setActionDashboardlist';
import setActionTaskContextExpColaps from '../../actions/setActionTaskContextExpColaps'


const $ = window.$;

var modal;
var indicatorCounter = 0;
var ListDataUI;
var ListDataFull;
var folderid;
var notificationsCount
//var UEvents = {
//    CLOSEWINDOW: "closeWindow",
//    DATATRANSFER: "dataTransfer",
//    CLOSEWINDOWANDREFRESH: "closeWindowAndRefresh",
//    PROCEDURECOMPLETED: "procedureCompleted",
//    PROCEDURECOMPLETEDWITHREFRESH: "procedureCompletedWithRefresh",
//    PROCEDURECOMPLETEDWITHMESSAGE: "procedureCompletedWithMessage",
//    PROCEDUREFAILEDWITHERROR: "closeWindowAndRefresh",
//    PROCEDUREFAILED: "procedureFailed",
//    ACTION: "action"

//}
function GroupTemplate(item) {
    return <div>Role: {item.key}</div>;
}
function searchingfor(term) {
  

    return function (x) {
        return x.name.toLowerCase().includes(term.toLowerCase()) || !term;
    }
}
//window.addEventListener("message", function (message) {
//    var dataFromBDV = JSON.parse(message.data)
  
//        if (UEvents.CLOSEWINDOW === dataFromBDV.mainevent) {
//            console.log('close window')
//            window.close()
            
//        }
//        else if (UEvents.DATATRANSFER === dataFromBDV.mainevent) {
//            console.log('DATATRANSFER')
//        }
//        else if (UEvents.CLOSEWINDOWANDREFRESH === dataFromBDV.mainevent) {
//            console.log('save and refresh')
//        }
//        else if (UEvents.PROCEDURECOMPLETED === dataFromBDV.mainevent) {
//            console.log('PROCEDURECOMPLETED')
//        }
//        else if (UEvents.PROCEDURECOMPLETEDWITHREFRESH === dataFromBDV.mainevent) {
//            console.log('PROCEDURECOMPLETEDWITHREFRESH')
//        }
//        else if (UEvents.PROCEDURECOMPLETEDWITHMESSAGE === dataFromBDV.mainevent) {
//            console.log('PROCEDURECOMPLETEDWITHMESSAGE')
//        }
//        else if (UEvents.PROCEDUREFAILEDWITHERROR === dataFromBDV.mainevent) {
//            console.log('PROCEDUREFAILEDWITHERROR')
//        }
//        else if (UEvents.PROCEDUREFAILED === dataFromBDV.mainevent) {
//            console.log('PROCEDUREFAILED')
//        }
//        else if (UEvents.ACTION === dataFromBDV.mainevent) {
//            console.log('ACTION')
//        }
//        else {
//            console.log('error')
//        }
//})
//var UEvents = {
//    CLOSEWINDOW: "closeWindow",
//    DATATRANSFER: "dataTransfer",
//    CLOSEWINDOWANDREFRESH: "closeWindowAndRefresh",
//    PROCEDURECOMPLETED: "procedureCompleted",
//    PROCEDURECOMPLETEDWITHREFRESH: "procedureCompletedWithRefresh",
//    PROCEDURECOMPLETEDWITHMESSAGE: "procedureCompletedWithMessage",
//    PROCEDUREFAILEDWITHERROR: "closeWindowAndRefresh",
//    PROCEDUREFAILED: "procedureFailed",
//    ACTION: "action"

//}
class TaskView extends React.Component {

    //TM(Thanasis Mourselas): The constructor for a React component is called before it is mounted. When implementing the constructor for a React.Component subclass, 
    //you should call super(props) before any other statement.Otherwise, this.props will be undefined in the constructor, which can lead to bugs.
    constructor(props) {
        super(props);
        
        this.state = {
            indicatorVisible: false,
            folderNameTabs: null,
            notifications: [],
            notificationsCount: '',
            useCache: false,
            accordionProtocolData: [],
            data: [],
            term: '',
            searchtask: [],
        };
        this.props.currCacheState(true)
        this.setCurrentObject = this.setCurrentObject.bind(this);
        this.setUseCache = this.setUseCache.bind(this);
        this.selectProtocolAccordion = this.selectProtocolAccordion.bind(this);
        //this.renderItem = this.renderItem.bind(this);
        if (this.props.usedataState !== undefined) {

            this.fetchNotifications()
        }
        if (this.props.contextExpandCollapse == undefined) {

            this.props.contextExpandCollapseSet(false)

        }
        this.searchhandler = this.searchhandler.bind(this);
        if (this.props.roledataId !== undefined) {
            this.fetchTask()
        }
    }
    shouldComponentUpdate(nextProps, nextState) {
        
        //if (this.props.windowpopupState != nextProps.windowpopupState) {
        //    return true;
        //}
        if (this.props.contextExpandCollapse !== nextProps.contextExpandCollapse) {
            return true
        }
        if (this.props.roledataId != nextProps.roledataId) {
            return true;
        }
        if (this.props.themeState !== nextProps.themeState) {
            return true;
        }
        if (this.state.indicatorVisible !== nextState.indicatorVisible) {
            return true;
        }
        if (nextState.term != this.state.term) {
            return true;
        }
       
        if (this.props.taskcontextExpandCollapse !== nextProps.taskcontextExpandCollapse) {
            return true
        }
    }

    setUseCache(e) {
        this.props.currCacheState(e)
        this.setState({ useCache: e })
    }

    fetchNotifications() {
        FetchData('/api/Events/GetNotifications/' + this.props.usedataState)
            .then((data) => {
                if (data.data != null) {
                    this.setState({
                        notifications: data.data,
                        notificationsCount: data.data.length
                    })
                    notificationsCount = data.data.length
                    this.props.currNotificationsSet(data.data)
                    this.props.currNotificationsCountSet(data.data.length)
                }
            }).catch(function (error) {
                if (error == "TOKEN_REFRESH_EXCEPTION") {
                    alert('Your login session has expired, please log in again.')
                    window.location.href = '/';
                }
            });
    }

    fetchTask = async () => {
       
        try {

           // if (this.props.notifications !== undefined) {


              


                //if (this.props.roledataId !== undefined) {

                    FetchData('/api/RTFCW/RoleTasksA/' + this.props.roledataId)

                        .then((data) => {

                            data.data.map((i) => {
                                i.name = i.name.replace(/,/g, '').replace(/'/g, '').replace(/:/g, '').replace(/[()]/g, '');

                            })
                            var byposition = data.data.slice(0)

                            byposition.sort(function (a, b) {
                                return a.PositionInBranch - b.PositionInBranch;
                            });
                            var nestTask = (items, id = 0, link = 'idparent') =>
                                items
                                    .filter(item => item[link] === id)
                                    .map(item => ({ ...item, items: nestTask(items, item.id) }));
                            nestTask(byposition);
                            let task = nestTask(byposition);

                            let removeEmpty = (task) => {
                                Object.keys(task).forEach(key =>
                                    (key === 'items' && task[key].length === 0) && delete task[key] ||
                                    (task[key] && typeof task[key] === 'object') && removeEmpty(task[key])
                                );
                                return task;
                            };
                           // var taskwithNotify = removeEmpty(task)

                           // this.treeCount(taskwithNotify)

                            this.setState({
                               // Task: taskwithNotify,
                                searchtask: data.data

                            })
                            //if (this.props.taskIdState === undefined) {
                            //    this.props.taskNameSet(this.state.Task[0].name)
                            //    this.props.taskIdSet(this.state.Task[0].id)
                            //}
                        })
               // }
            //} else {

            //    FetchData('/api/RTFCW/RoleTasksA/' + this.props.roledataId)
            //        .then((data) => {

            //            data.data.map((i) => {
            //                i.name = i.name.replace(/,/g, '').replace(/'/g, '').replace(/:/g, '').replace(/[()]/g, '');

            //            })
            //            var byposition = data.data.slice(0);
            //            byposition.sort(function (a, b) {
            //                return a.PositionInBranch - b.PositionInBranch;
            //            });
            //            var nestTask = (items, id = 0, link = 'idparent') =>
            //                items
            //                    .filter(item => item[link] === id)
            //                    .map(item => ({ ...item, items: nestTask(items, item.id) }));
            //            nestTask(byposition);
            //            let task = nestTask(byposition);
            //            let removeEmpty = (task) => {
            //                Object.keys(task).forEach(key =>
            //                    (key === 'items' && task[key].length === 0) && delete task[key] ||
            //                    (task[key] && typeof task[key] === 'object') && removeEmpty(task[key])
            //                );
            //                return task;
            //            };
            //            var taskwithNotify = removeEmpty(task)

            //            this.treeCount(taskwithNotify)
            //            this.setState({
            //                Task: removeEmpty(task),
            //                searchtask: data.data
            //            })
            //            if (this.props.taskIdState === undefined) {
            //                this.props.taskNameSet(this.state.Task[0].name)
            //                this.props.taskIdSet(this.state.Task[0].id)
            //            }
            //        })
            //}

        }

        catch (error) {
            console.error(error);
        }


    }

    //TM(Thanasis Mourselas): executed after the component did mount on the dom. This method is executed once in a lifecycle of a component and after the first render.
    componentDidMount() {
        window.addEventListener('storage', () => {

            if (localStorage.getItem('rememberMe') === 'refreshWorkplace') {
                //this.fetchNotifications()
                localStorage.setItem('rememberMe', 'notrefreshWorkplace');
            }
        });
        this.props.currDropdownflagState(false)
        if (widthResolution === 1600) {
            document.getElementById("main").style.marginTop = "-50px";
        }
        if (widthResolution === 1776) {
            document.getElementById("main").style.marginTop = "-30px";
        }
        if (widthResolution === 1920) {

            document.getElementById("main").style.marginTop = "-15px";

        }
        var widthResolution = window.innerWidth
        this.props.contextExpandCollapseSet(true)
        this.props.currFooterSet('Hide')
        this.props.history.push('./taskview');

        //TM(Thanasis Mourselas): close open side nav bars
        document.getElementById("mySidenav").style.width = "360px";
        document.getElementById("main").style.marginRight = "360px";
        document.getElementById("main").style.marginLeft = "0px";
        document.getElementById("mySidenav").style.marginTop = "-47px";
        document.getElementById('btnMenu').style.visibility = 'hidden';
        document.getElementById('Footer').style.height = '0%';
        document.getElementById('split').style.visibility = 'visible';
        const query = new URLSearchParams(this.props.location.search)

        folderid = query.get('folderid')
        var roleid = query.get('roleid')
        var taskid = query.get('taskid')
        var dirid = query.get('dirid')


        if (this.props.usedataState === undefined) {

            var url = '?folderid=' + folderid
                + "&roleid=" + roleid
                + "&taskid=" + taskid
                + "&dirid=" + dirid
            window.open(url, '_self');
        }

        if (folderid !== null && folderid !== undefined) {
          
            var postparameters = {
                userId: this.props.usedataState,
                roleId: null,
                taskId: null,
                folderId: folderid
            };
            // this.setIndicatorVisibility(true)
            FetchData('/api/RTFCW/URTFHelper/', 'POST', postparameters)
                .then((data) => {
                    var taskRole = data.data.find(tr => tr.roleId == roleid && tr.taskId == taskid)
                    ListDataUI = data.data
                    if (taskRole === undefined) {
                       
                        ListDataUI.map((e) => {
                            e.key = e.roleName;
                            e.items = [
                                e.taskName,
                            ]
                            delete e.roleName;
                            delete e.folderId;
                            delete e.folderName;
                            delete e.roleId;
                            delete e.taskId;
                            delete e.taskName;
                        });

                        modal = document.getElementById("protocolModal");
                        // Get the <span> element that closes the modal
                        var span = document.getElementsByClassName("closeProtocol")[0];
                        // When the user clicks the button, open the modal 
                        modal.style.display = "block";
                        // When the user clicks on <span> (x), close the modal
                        span.onclick = function () {
                            modal.style.display = "none";
                        }
                        // When the user clicks anywhere outside of the modal, close it
                        window.onclick = function (event) {
                            if (event.target == modal) {
                                modal.style.display = "none";
                            }
                        }
                    } else {

                        this.props.idRoleSet(roleid)
                        this.props.nameRoleSet(taskRole.roleName)
                        this.props.taskIdSet(taskid)
                        this.props.taskNameSet(taskRole.taskName)
                        this.props.folderIdSet(folderid)
                        this.props.folderNameSet(taskRole.folderName)
                        this.props.directoryIdSet(dirid)
                        this.setState({ folderNameTabs: taskRole.folderName })
                    }
                }).catch(function (error) {
                    if (error == "TOKEN_REFRESH_EXCEPTION") {
                        alert('Your login session has expired, please log in again.')
                        window.location.href = '/';
                    }
                }.bind(this));
        }
    }
    EditnavigateTaskSearch(e, id) {
        if (id != undefined) {
            var splitId = id.split(',')
            this.props.taskIdSet(splitId[0])
            this.props.taskNameSet(splitId[1])
        }
        this.setState({
            term: '',
        })
    }
    searchKeyPress(e) {
        if (e.key === "Enter") {
            e.preventDefault();
        }
    }
    searchhandler(event) {
        //alert('event')
        //alert(event.target.value )
        this.setState({ term: event.target.value })
    }
    setCurrentObject(notif) {

        var postparameters
        if (notif.id === undefined) {

            var notificationDropdown = notif.split(',')
            var notifRoleid = notificationDropdown[0]
            var notifFolderid = notificationDropdown[1]
            postparameters = {
                userId: this.props.usedataState,
                roleId: notifRoleid,
                taskId: null,
                folderId: notifFolderid
            };

        } else {

            postparameters = {
                userId: this.props.usedataState,
                roleId: notif.roleID,
                taskId: null,
                folderId: notif.folderID
            };
        }



        this.setIndicatorVisibility(true)
        FetchData('/api/RTFCW/URTFHelper/', 'POST', postparameters)
            .then((data) => {
                var taskRole = data.data[0]
                this.props.idRoleSet(taskRole.roleId)
                this.props.nameRoleSet(taskRole.roleName)
                this.props.taskIdSet(taskRole.taskId)
                this.props.taskNameSet(taskRole.taskName)
                this.props.folderIdSet(taskRole.folderId)
                this.props.folderNameSet(taskRole.folderName)
                this.props.directoryIdSet(1)
                this.props.currObjectSet([notif.objectID])
                this.setState({ folderNameTabs: taskRole.folderName })

                this.setIndicatorVisibility(false)
            }).catch(function (error) {
                this.setIndicatorVisibility(false)
                if (error == "TOKEN_REFRESH_EXCEPTION") {
                    alert('Your login session has expired, please log in again.')
                    window.location.href = '/';
                }
            }.bind(this));
    }

    setIndicatorVisibility = e => {
        
        if (e === true) {

            indicatorCounter++;

            if (this.state.indicatorVisible === false) {

                this.setState({ indicatorVisible: true })
            }
        }
        else {

            if (this.state.indicatorCounter != 0) {

                indicatorCounter--;
            }
            if (indicatorCounter === 0 && this.state.indicatorVisible === true) {

                this.setState({ indicatorVisible: false })
            }
        }
    }

    handleClickAlert = (e) => {
        this.setState({ messageModal: e })
        modal = document.getElementById("myModal");
        var btn = document.getElementById("myBtn");
        var span = document.getElementsByClassName("close")[0];
        modal.style.display = "block";
        span.onclick = function () {
            modal.style.display = "none";
        }
        window.onclick = function (event) {
            if (event.target == modal) {
                modal.style.display = "none";
            }
        }
    }

    handleCloseModal(e) {
        modal = document.getElementById("myModal");
        modal.style.display = "none";
    }
    selectProtocolAccordion = (e) => {
        if (folderid !== null && folderid !== undefined) {
            var postparameters = {
                userId: this.props.usedataState,
                roleId: null,
                taskId: null,
                folderId: folderid
            };
            FetchData('/api/RTFCW/URTFHelper/', 'POST', postparameters)
                .then((data) => {
                    ListDataFull = data.data

                    var RoleName = e.itemData.key
                    var TaskName = e.itemData.text
                    var protocolData = data.data.find(tr => tr.roleName == RoleName && tr.taskName == TaskName)

                    this.props.idRoleSet(protocolData.roleId)
                    this.props.nameRoleSet(protocolData.roleName)
                    this.props.taskIdSet(protocolData.taskId)
                    this.props.taskNameSet(protocolData.taskName)
                    this.props.folderIdSet(protocolData.folderId)
                    this.props.folderNameSet(protocolData.folderName)

                }).catch(error => {
                    if (error == "TOKEN_REFRESH_EXCEPTION") {
                        alert('Your login session has expired, please log in again.')
                        window.location.href = '/';
                    }
                })
            modal = document.getElementById("protocolModal");
            modal.style.display = "none";
        }
    }
    closesidebar = (ee2) => {
       // alert('1')
        if (this.props.contextExpandCollapse === true) {
          //  alert('1,1')
            this.props.actionDashboardlistset(undefined)
            document.getElementById('taskArea').style.visibility = 'hidden';
            document.getElementById('tasklabel').style.visibility = 'hidden';
            document.getElementById('taskForm').style.visibility = 'hidden';
            document.getElementById('taskTree').style.visibility = 'hidden';
            document.getElementById('taskAreaCollapse').style.visibility = 'visible';
            document.getElementById('taskAreaCollapse').style.marginTop = '24px';
            //document.getElementById('tasklabel').style.marginTop = '30px';
            document.getElementById('labelTask').style.visibility = 'visible';
            document.getElementById('labelContext').style.visibility = 'visible';
            document.getElementById('taskArea').style.marginTop = '-100px';
            document.getElementById('split').style.visibility = 'hidden';
           
          
        } else {
         //   alert('1,2')
            document.getElementById('taskAreaCollapse').style.visibility = 'visible';
            document.getElementById('taskArea').style.visibility = 'hidden';
            document.getElementById('taskAreaCollapse').style.marginTop = '24px';
            document.getElementById('taskArea').style.marginTop = '-100px';
            document.getElementById('labelTask').style.visibility = 'visible';
            document.getElementById('labelContext').style.visibility = 'visible';
            //this.props.actionTaskContextExpandCollapse(true)
           
        }
        this.props.actionTaskContextExpandCollapse(false)
      
        // return 
    }
    opensidebar = (ee) => {
        // alert('open')
        this.props.actionDashboardlistset(undefined)
        if (this.props.contextExpandCollapse === false) {
         //  alert('2')
            //document.getElementById('taskArea').style.visibility = 'hidden';
            //document.getElementById('tasklabel').style.visibility = 'hidden';
            //document.getElementById('taskForm').style.visibility = 'hidden';
            //document.getElementById('taskTree').style.visibility = 'hidden';
            //document.getElementById('taskAreaCollapse').style.visibility = 'hidden';
            ////document.getElementById('taskArea').style.visibility = 'visible';
            //document.getElementById('tasklabel').style.marginTop = '10px';
            //document.getElementById('labelTask').style.visibility = 'hidden';
            //document.getElementById('labelContext').style.visibility = 'hidden';
            //document.getElementById('tasklabel').style.visibility = 'visible';
            //document.getElementById('taskForm').style.visibility = 'visible';
            //document.getElementById('taskTree').style.visibility = 'visible';
            document.getElementById('taskAreaCollapse').style.visibility = 'hidden';
            document.getElementById('taskArea').style.visibility = 'visible';
            document.getElementById('taskArea').style.marginTop = '-100px';
            //document.getElementById('tasklabel').style.marginTop = '10px';
            document.getElementById('labelTask').style.visibility = 'hidden';
            document.getElementById('labelContext').style.visibility = 'hidden';
            document.getElementById('split').style.visibility = 'visible';
           
            this.props.actionTaskContextExpandCollapse(true)
        } else {
          //  alert('3')
            document.getElementById('tasklabel').style.visibility = 'visible';
            document.getElementById('taskForm').style.visibility = 'visible';
            document.getElementById('taskTree').style.visibility = 'visible';
            document.getElementById('taskAreaCollapse').style.visibility = 'hidden';
            document.getElementById('taskArea').style.visibility = 'visible';
            document.getElementById('taskArea').style.marginTop = '-100px';
            document.getElementById('tasklabel').style.marginTop = '10px';
            document.getElementById('labelTask').style.visibility = 'hidden';
            document.getElementById('labelContext').style.visibility = 'hidden';
            document.getElementById('split').style.visibility = 'visible';
            this.props.actionTaskContextExpandCollapse(true)
        }
    }
    render() {
       
       // var style = {};
        this.state.searchtask.map((i) => {
            i.name = i.name.replace(/,/g, '').replace(/'/g, '').replace(/:/g, '').replace(/[()]/g, '');
        })

        var searchtask
        if (this.props.taskNameState != undefined) {
            searchtask = this.props.taskNameState.replace(/,/g, '').replace(/'/g, '').replace(/:/g, '').replace(/[()]/g, '');
        }

        //var component = this;
        var style = {};
        if (!this.state.term) {

            style.display = 'none'
            style.height = '0px'
        } else {
            style.overflowY = 'scroll'
            style.overflowX = 'hidden'

            style.height = '200px'

        }
        var taskviewStyles;

        if (this.props.themeState === false || this.props.themeState === undefined) {

            taskviewStyles = window.defaultTheme;
        } else {

            taskviewStyles = window.darkTheme;
        }
        const { term, people } = this.state;
        const { selectedItems, multiple, collapsible, animationDuration } = this.state;
        return (
            //TM Child components for TaskView Component
            <div>
                <div id="protocolModal" class="modalProtocol">
                    <div className="modal-content" style={{ overflowY: 'scroll', height: '600px', paddingTop: '0px' }}>
                        <span style={{ zIndex: '954', position: "fixed", width: '816px', backgroundColor: '#fff' }} className="closeProtocol">&times;</span>
                        <p style={{ position: 'fixed', backgroundColor: '#fff', marginTop: '25px', width: '816px', zIndex: '1000', height: '80px' }}><img style={{ marginTop: '0px', verticalAlign: 'bottom' }} src={LogoTA} /> Task Assistant</p>
                        <h3 style={{ borderBottom: '0px', height: '10px', fontStyle: 'italic', color: '#236389', marginTop: '105px' }}>The selected object is available to you under the following Role/Task/Folder compinations</h3>
                        <h3 style={{ borderBottom: '0px', height: '10px', fontStyle: 'italic', color: '#236389' }}>Please select the folder in which you would like to access this object</h3>
                        <div className="list-container" >
                            <List
                                dataSource={ListDataUI}
                                height="100%"
                                grouped={true}
                                collapsibleGroups={true}
                                groupRender={GroupTemplate}
                                onItemClick={this.selectProtocolAccordion}
                                collapsible={collapsible}

                                scrollingEnabled={false}

                            />
                        </div>
                        {/*<div class="modal-footer">
                            <button type="button" class="btn btn-default" data-dismiss="modal" onClick={this.handleClickOptionRadio} >OK</button>
                            <button type="button" class="btn btn-default" data-dismiss="modal" onClick={this.handleCloseModal}>Cancel</button>
                        </div>*/}
                        <div class="modal-footer">

                        </div>
                    </div>
                </div>
                {/*<div id="myModal" class="modalTaskview">
                    <div className="modal-contentTaskview">
                        <span className="closeTaskview">&times;</span>
                        <img style={{ width: '60px', height: '50px', backgroundColor: '#ffffff' }} src={require('../../images/alert.png')} />
                        <p>ALERT</p>
                        <span style={{ fontSize: '20px', fontWeight: '40' }}>This {this.state.messageModal} is not supported. Please contact for support.</span>
                        <div class="modal-footerTaskview" style={{ float: 'right', marginTop: '7px' }}>
                            <button type="button" class="btn btn-default" data-dismiss="modal" onClick={this.handleCloseModal} >OK</button>
                        </div>
                    </div>
                </div>*/}
                <div>
                    <LoadPanel id="indicator" visible={this.state.indicatorVisible} />

                    <Header notifications={this.state.notifications.slice(0, 5)} setCurrentObject={this.setCurrentObject} setUseCache={this.setUseCache} />
                    <div style={{ height: '100%' }} >
                        <Folders />
                    </div>

                    <div style={{ height: '100%' }} >
                        <WorkPlace indicatorVisible={this.setIndicatorVisibility} folderNameTabs={this.state.folderNameTabs} useCache={this.state.useCache} />
                    </div>
                    <aside className="control-sidebar control-sidebar-dark">
                        <div id="mySidenav" className="sidenav" style={taskviewStyles.RightComponent}  >

                            <div style={{ height: '100%', zIndex:'-1000' }} >
                                {/*<ChangeRole />*/}
                                <div id="taskAreaCollapse" onClick={this.opensidebar} style={{ marginTop: '24px' }} >
                                    <span style={{ cursor: 'pointer', marginLeft: '8px' }}>
                                        <SvgExpandCollapseLeft />
                                    </span>
                                    <h4 id="labelTask" style={{ marginLeft: '12px', fontSize: '14px', cursor: 'pointer', marginTop: '30px' }} className="labelTask">Tasks</h4>
                                    <h4 id="labelContext" style={{ marginLeft: '12px', marginTop: '10px', fontSize: '14px', cursor: 'pointer' }} className="labelTask">Contexts</h4>
                                </div>
                                <div id="taskArea" style={{ marginTop: '-100px' }}>

                                    {/*<h4 className="labelTask" style={taskStyles.rightFonts}>Task Navigator</h4> <br />*/}
                                    <span style={{ cursor: 'pointer', marginLeft: '21px', height: '16px' }} onClick={this.closesidebar}>
                                        <SvgExpandCollapseRight />
                                    </span>
                                </div>
                                {
                                    this.props.contextExpandCollapse !== false &&
                                    <div>
                                        <div id="tasklabel">
                                            <div>
                                                <h4 className="labelTask">Task Navigator</h4>
                                            </div>
                                        </div>
                                        <div>
                                            <div id="taskForm">
                                                {/*(TM 29-01-19 )input task search*/}
                                                <form style={{ width: '95%' }}>
                                                    <input
                                                        onKeyPress={this.searchKeyPress}
                                                        placeholder="Search..."
                                                        className="inputTask"
                                                        id="inputTask"
                                                        type="text"
                                                        onChange={this.searchhandler}
                                                        value={term}
                                                    />
                                                </form>
                                            </div>
                                            <div style={style} >
                                                <table>
                                                    {
                                                        this.state.searchtask.filter(searchingfor(term)).map(task =>

                                                            <tr id="searchTask" key={task.name} style={{ fontSize: '13px', marginTop: '2px', border: '0px', color: '#4D4D4D' }}>
                                                                <td><i className="glyphicon glyphicon-chevron-right" style={{ cursor: 'Pointer', color: '#428bca', fontSize: '10px', top: '3px' }}></i><a className="tdFilter" style={{ marginLeft: '26px', marginTop: '-18px', cursor: 'Pointer' }} onClick={(e) => this.EditnavigateTaskSearch(e, task.id + "," + task.name)}>{task.name.replace("<b style=margin-right:69px>", "").replace("</b>", "")}</a></td>
                                                            </tr>

                                                        )
                                                    }
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                   
                                }
                                <div id="split">
                                    {
                                        this.props.contextExpandCollapse !== false ?
                                            <SplitterLayout vertical
                                                primaryMinSize={1}
                                                secondaryMinSize={400}
                                                // percentage={false}

                                                borderColor="red" primaryIndex={0}>
                                                <div className="divtask"><Task /></div>
                                                <div><Context id="contextArea" indicatorVisible={this.setIndicatorVisibility} /></div>
                                            </SplitterLayout>: 
                                        this.props.contextExpandCollapse === false &&
                                            <div>
                                              
                                                <div><Context id="contextArea" indicatorVisible={this.setIndicatorVisibility} /></div>
                                            </div>   
                                   
                                       }
                                </div>
                            </div>
                        </div>
                    </aside>
                    <Footer setCurrentObject={this.setCurrentObject} />
                </div >
            </div>
        );
    }

}
const mapStateToProps = state => {
    return {
        usedataState: state.userData,
        userNameData: state.userDataName,
        themeState: state.currentThemeName,
        roledataId: state.roleDataId,
        folderExpandCollapse: state.currFolderExpandCollapse,
        taskcontextExpandCollapse: state.currTaskContextExpandCollapse,
        contextExpandCollapse: state.currContextExpandCollapse,
        actionMessage: state.currentActionmessage,
        //windowpopupState: state.windowpopup,
    }
};

const mapDispatchToProps = dispatch => {
    return {
        idRoleSet: payload => dispatch(setRoleIdAction(payload)),
        nameRoleSet: payload => dispatch(setRoleNameAction(payload)),
        taskIdSet: payload => dispatch(setTaskIdAction(payload)),
        taskNameSet: payload => dispatch(setTaskNameAction(payload)),
        folderIdSet: payload => dispatch(setFolderIdAction(payload)),
        folderNameSet: payload => dispatch(setFolderNameAction(payload)),
        directoryIdSet: payload => dispatch(setDirectoryIdAction(payload)),
        currObjectSet: payload => dispatch(setCurrentObjectId(payload)),
        currNotificationsCountSet: payload => dispatch(setNotificationsCountAction(payload)),
        currNotificationsSet: payload => dispatch(setActionNotifications(payload)),
        currFooterSet: payload => dispatch(setCurrentFooterAction(payload)),
        actionFolderExpandCollapse: payload => dispatch(setActionFolderExpColaps(payload)),
        contextExpandCollapseSet: payload => dispatch(setContextsExpandCollapse(payload)),
        currCacheState: payload => dispatch(setCurrentCache(payload)),
        currDropdownflagState: payload => dispatch(setActiondropdownFlag(payload)),
        actionDashboardlistset: payload => dispatch(setActionDashboardlist(payload)),
        actionTaskContextExpandCollapse: payload => dispatch(setActionTaskContextExpColaps(payload)),
        taskNameSet: payload => dispatch(setTaskNameAction(payload)),
        taskIdSet: payload => dispatch(setTaskIdAction(payload)),
        contextExpandCollapseSet: payload => dispatch(setContextsExpandCollapse(payload)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(TaskView);



// WEBPACK FOOTER //
// ./src/components/TaskView/Taskview.js